module.exports = __webpack_public_path__ + "img/envelope-open-dollar.29f48861.svg";